export default __webpack_public_path__ + "static/media/footer-call-action-bg.a40fac0f.png";